import React from "react";
import {Helmet} from "react-helmet";
import {routes, site} from "../config";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";
import {Link} from "react-router-dom";


export default class OptInPage extends React.Component {
  componentDidMount() {
    if (window.localStorage.getItem('optOut')) {
      window.localStorage.removeItem('optOut');
      window.location.reload();
    } else {
      window.analytics.page("Admin", "Opt In");
    }
  }

  render() {
    window.prerenderReady = true;
    return (
      <div className={'page-opt-in'}>
        <Helmet>
          <title>{site.titlePrefix + 'Opt In'}</title>
          {metaTitles(site.titlePrefix + 'Opt In')}
          {metaDescriptions('Opt in for analytics tracking')}
        </Helmet>
        <section className={'hero'} id={'hero'}>
          <div className={'container'}>
            <h1 className={'title'}>Opted In</h1>
            <div className={'brief'}>
              <p>You've successfully opted in for tracking on this device.</p>
              <p><Link to={routes.home}>Back to home.</Link></p>
            </div>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/OptInPage.js